import React from 'react';
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";
import { Black } from "../../../../Constants/ColorChart";
import CalendarIcon from "../../../Icons/Calendar/Calendar";
import ClearIcon from "../../../Icons/Delete/Delete";
import "./InputDate.css"

function InputDate( props ) {
    return (
        <div className={ (props.properDate !== '' ? 'selected' : 'clear') + " filter-box filter-date-box" }>
            <input
                className={ props.isFormField ? "form-field filter-field" : "filter-field" }
                value={ props.properDate }
                onChange={ () => {
                } }
            />
            <input
                required={ props.required }
                className={ " filter-field filter-date-field" }
                type="date"
                name={ props.name }
                value={ props.value }
                onChange={ event => {
                    props.handleChange( event )
                } }
                disabled={ props.isDisabled }
            />
            <FeatherIconWrapper
                color={ Black }
                fillColor={ "none" }
                iconStyle={ { width: "16px", verticalAlign: "middle", strokeWidth: "2px" } }
                Icon={ CalendarIcon }/>
            {
                props.value && props.clearValue &&
                <button className="date-clear" onClick={ event => {
                    event.preventDefault();
                    props.clearValue();
                } }>
                    <FeatherIconWrapper
                        color={ Black }
                        fillColor={ "none" }
                        iconStyle={ { width: "16px", verticalAlign: "middle", strokeWidth: "2px" } }
                        Icon={ ClearIcon }/>
                </button>
            }
        </div>

    );
}

export default InputDate;